import { DearisMultiBuild } from "./DearisMultiBuild";

export default function () {
  return <DearisMultiBuild />;
}
